var _style, _path, _polygon;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMixing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 360 360",
    style: {
      enableBackground: "new 0 0 360 360"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n        .mixing-st0{fill:#FFFFFF;stroke:currentColor;stroke-width:10;stroke-miterlimit:10;}\r\n        .mixing-st1{fill:#FFFFFF;stroke:currentColor;stroke-width:8;stroke-miterlimit:10;}\r\n    ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "mixing-st0",
    d: "M333.6,37.4H180h0H26.4c-5.9,0-10.6,4.3-10.6,9.5V175v0v3.6c0,0.4,0,0.8,0.1,1.2 c2.9,79.3,75.3,142.7,164.2,142.7h0c88.9,0,161.3-63.5,164.2-142.7c0.1-0.4,0.1-0.8,0.1-1.2V175v0V46.9 C344.2,41.6,339.5,37.4,333.6,37.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "mixing-st1",
    points: "120.6,111.9 179.9,168.4 239.4,111.9 180.2,169.2 179.9,248.1 179.5,169.2 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMixing);
export default __webpack_public_path__ + "static/media/mixing.0cfdf39976913b1df60ebf7d3df7534e.svg";
export { ForwardRef as ReactComponent };